import { handle420 } from 'apis/HandleError';
import { handleGenericError } from 'apis/HandleError';
import { fetchdata } from './FetchData';
import { apiConfig } from 'config';

export function getSupportedCommissioningSoftwareVersions() {
  let url = apiConfig.romComAvailablity;

  return fetchdata(url, { method: 'GET' }).catch((e) => {
    console.log('fetch data error = ' + e.message);
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        handleGenericError();
    }
    return;
  });
}
